<template>
	<div class="dunk"  :class="{ 'active' : lower }">

		

		

			<img :src="require(`../assets/img/${startBeakerImg}`)" 
				class="beaker start-beaker"
				:class="{'show': !showEnd || (endBeakerImg===false && showEnd === true)}" key="startbeaker">

			<img :src="require(`../assets/img/${reactions[startMetalImg].endBeakerImg}`)"
			 	class="beaker end-beaker"
				:class="{'show' : showEnd === true && reactions[startMetalImg].endBeakerImg !== false, 'slow-trans' : slowTrans }" 
				key="endbeaker" 
				v-if="startMetalImg !== false && reactions[startMetalImg].endBeakerImg !== false">


		<div class="metal-contain" :class="{ 'hold': hold || lower }">
				<img :src="require(`../assets/img/${startMetalImg}.png`)"
					class="metal start-metal" 
					:class="{ 'show': !showEnd }" 
					v-if="(startMetalImg !== false)">
				<img :src="require(`../assets/img/${reactions[startMetalImg].endMetalImg}`)" 
					class="metal end-metal" 
					:class="{ 'show': showEnd, 'slow-trans' : slowTrans }" 
					v-if="startMetalImg !== false && reactions[startMetalImg].endMetalImg !== false && showEnd">
		</div>

		<div class="formula-contain" v-if="formula" :class="{'single' : single}">
			<p class="formula" v-html="formula"></p>
		</div>
	</div>
</template>


<script>
export default {
	name:"Dunk",
	props:{
		startBeakerImg: String,
		startMetalImg: {
			type: [Boolean, String],
			default: false,
			required: false
		},
		hold: {
			type: Boolean,
			default: false,
			required: false
		},
		endBeakerImg:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		endMetalImg:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		formula:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		animate:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		showEnd: {
			type: Boolean,
			default: false
		},
		lower: {
			type: Boolean,
			default: false
		},
		reactions:{
			type: [Boolean, Object],
			default: false
		},
		single:{
			type: Boolean,
			default: false
		},
		slowTrans:{
			type: Boolean,
			default: false
		}
	},
}
</script>


<style lang="scss" scoped>

.dunk{
	position: relative;
	width: 100%;

	.beaker{
		opacity: 0;
		
		&.slow-trans{
			transition: opacity 1000ms;
		}
		
		&.end-beaker{
			position: absolute;
			top: 0;
			left: 0;
			transition: opacity 1000ms;
		}

		&.show{
			opacity: 1;
		}
	}

	.metal-contain{
		position: absolute;
		width: 100%;
		top: -50%;
		left: 0%;
		z-index: -1;
		display: flex;
		justify-content: center;
		transition: all 500ms;

		&.hold{
			top: 13%;
		}

		.metal{
			width: 10%;
			position: relative;

			&.slow-trans{
				transition: opacity 1000ms;
			}

			&.end-metal{
				position: absolute;
				bottom: 0;
				z-index: 2;
			}
		}
	}
}

.formula-contain{
	display: flex;
	justify-content: center;
	align-items: center;

	p{
		margin: 0;
		position: absolute;
		bottom: 15px;
	}

	&.single{
		p{
			font-size: 1.3rem;
			bottom: 15%;
		}
	}
}

.fade-enter-active, .fade-leave-active {
	transition: all 1000ms;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.fade-enter-active{
	position: absolute;
}
</style>